import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { dataTestId } from '@services/data-test-id';


/**
 * @description Renders the login link in the navbar: plain "Sign in" text, no pill border.
 */
export const LoginButton = ({ toEmployerLogin = false, className = '' }: { toEmployerLogin?: boolean, className?: string, locale?: Locale }) => {
  // translate
  const { t } = useTranslation('common');

  const href = toEmployerLogin ? '/login/recruiter' : '/login';

  return (
    <LinkStyled
      href={href}
      styling="text"
      size="sm"
      color="ink"
      className={`min-w-fit whitespace-nowrap md:ml-6 lg:order-last ${className}`}
      {...dataTestId('navbar.loginButton')}
    >
      {t('sign_in')}
    </LinkStyled>
  );
};
